module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_null@2x.02c1a11a.png";